import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../hooks/redux';
import { fetchUserProfile } from '../../store/authSlice';
import { Spin } from 'antd';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, token, user, isLoading } = useAppSelector(state => state.auth);
  const location = useLocation();

  useEffect(() => {
    // If we have a token but no user data, fetch the user profile
    if (token && !user && !isLoading) {
      dispatch(fetchUserProfile(token));
    }
  }, [token, user, isLoading, dispatch]);

  // Show loading spinner only during initial profile fetch (token present but user not yet loaded)
  if (isLoading && token && !user) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh' 
      }}>
        <Spin size="large" />
      </div>
    );
  }

  // If not authenticated, redirect to login with current location
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If authenticated, render the protected content
  return <>{children}</>;
};

export default ProtectedRoute;